import type { Messages } from '../en'

export const common: Messages['common'] = {
  appName: 'Smith Factory',
  loading: 'Carregando…',
  retry: 'Tentar novamente',
  cancel: 'Cancelar',
  close: 'Fechar',
  back: 'Voltar',
  continue: 'Continuar',
  or: 'ou',
  optional: 'opcional',
  genericError: 'Algo deu errado. Tente novamente.',
  requestFailed: (status) => `Falha na solicitação (${status})`,
  sessionExpired: 'Sua sessão expirou. Entre novamente.',
  language: 'Idioma',
  languageNameEn: 'English',
  languageNamePt: 'Português (Brasil)'
}
